import styled from "styled-components";
import { Box } from "@mui/material";
import Image from "../../image/image.component";

export const CMHeadingContainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  fontWeight: 500,
  fontSize: props.theme.fontSizes.h5,

  "& h3": {
    margin: 0,
    paddingRight: 25,
    paddingLeft: 18,
    fontFamily: props.theme.fontFamilies.workSans,
    fontWeight: "medium",
  },
  "& h3 span": {
    color: "#A80000",
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    maxWidth: 480,
  },
  [`@media${props.theme.breakpoints.xss}`]: {
    flexDirection: "column",
    maxWidth: 480,
    paddingLeft: 5,
  },
}));
export const CMDetails = styled.div((props) => ({
  display: "flex",
  position: "relative",
  marginTop: props.theme.spacers["1"],
  marginLeft: 18,
  h1: {
    margin: 0,
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "row",
    textAlign: "center",

    "& > div": {
      width: "100%",
    },
  },
}));
export const CMCarouselContainer = styled.div((props) => ({
  width: "12%",
  paddingTop: 0,
  "& .swiper": {
    paddingBottom: "10%",
  },

  "& img": {
    width: 59,
    height: 59,
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    width: "35% !important",
    maxWidth: "200px",
  },
}));
export const CMAuctionDescription = styled.div((props) => ({
  width: "32%",
  paddingTop: "2%",
  paddingLeft: "2%",
  fontSize: props.theme.fontSizes.h5,
  fontFamily: props.theme.fontFamilies.jost,
  fontWeight: "regular",
  paddingBottom: 17,

  "& h1": {
    letterSpacing: "-1.728px",
    fontFamily: props.theme.fontFamilies.workSans,
    fontSize: props.theme.fontSizes.h2,
    fontWeight: 500,
  },

  "& > h4": {
    margin: 0,
    fontWeight: 500,
    color: props.theme.palette.primary.main,
  },

  [`${CMCardContainer}`]: {
    display: "none",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    textAlign: "left",
    paddingTop: "3%",
    [`${CMCardContainer}`]: {
      width: "100%",
      display: "block",
      position: "unset",
      marginTop: props.theme.spacers["5"],
      marginBottom: props.theme.spacers["2"],

      "& > div > div": {
        width: "95%",
      },
    },
  },
}));
export const CMCardContainer = styled.div`
  width: 40%;
  position: absolute;
  right: 0;
  max-width: 453px;

  @media ${(props) => props.theme.breakpoints.lg} {
    display: none;
    max-width: 640px;
  }
`;
export const CMBox = styled(Box)((props) => ({
  textAlign: "left",
  backgroundColor: " #F3FAFC",
  borderRadius: "10px",
  height: "auto",
  marginTop: 18,
  padding: "1rem",
  fontFamily: props.theme.fontFamilies.jost,
  fontWeight: "normal",
  "& .orderField": {
    padding: "0 1rem",
  },
  "& .container": {
    // display: "flex",
    // flexDirection: "column",
    // paddingTop: "5%",
    // justifyContent: "center",
    // height: "auto",
    // fontWeight: "normal",

    "& .buyDropdown": {
      width: "100%",
      maxWidth: "100%",
      height: "40px",
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
    },
    "& .buyDropdown .MuiFormControl-root": {
      margin: "0 ",
    },
    "& .buyDropdown .MuiFormControl-root MuiSelect-select": {
      padding: "0 1rem",
    },
    "& .priceType": {
      width: "100%",
      maxWidth: "100%",
      height: "40px",
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
    },
    "& .priceType .MuiFormControl-root": {
      margin: "0 ",
    },
    "& .priceType .MuiFormControl-root MuiSelect-select": {
      padding: "0 1rem",
    },
    "& .duration": {
      width: 208,
      height: 53,
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
    },

    "& .units-column": {
      marginBottom: "0.8rem",
    },
    "& .units-column .label-column": {
      marginBottom: "0.3rem",
    },
    "& .units-column .label-column label": {
      fontSize: "1rem",
      fontWeight: "400",
      color: "#000",
      lineHeight: "1",
    },
    "& .units-column .input-column ": {
      fontSize: "1rem",
      fontWeight: "400",
      color: "#000",
      lineHeight: "1",
    },
    "& .combined-input-container": {
      display: "flex",
      alignItems: "center",
      paddingTop: 0,
    },
    "& .limit-input-container": {
      display: "flex",
      alignItems: "center",
      paddingTop: 5,
    },
    " & .text-input": {
      width: 50,
      height: 40,
      borderRadius: 5,
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      backgroundColor: "#429800",
      color: "white",
      padding: 5,
    },
    " & .limit-text-input": {
      width: 36,
      height: 39,
      borderRadius: 5,
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      padding: 5,
      border: "1px solid #ccc",
      textAlign: "center",
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
      borderRight: "none",
    },
    "& .unitTextInput": {
      width: "100%",
      height: "40px",
      border: "1px solid #ccc",
      fontSize: "16px !important",
      borderRadius: 5,
      padding: 5,
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
    },
    "& .limitTextInput": {
      width: "100%",
      height: "40px",
      border: "1px solid #ccc",
      fontSize: "16px !important",
      borderRadius: 5,
      padding: 5,
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
    },
    " & .estimation-text-input": {
      width: 100,
      height: 39,
      borderRadius: 5,
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      padding: 5,
      textAlign: "center",
      fontFamily: props.theme.fontFamilies.jost,
      fontSize: props.theme.fontSizes.h3,
      border: "none",
      backgroundColor: "transparent",
    },
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    height: "auto !important",
    backgroundColor: "#ffff",
    paddingTop: 0,
  },
  [`@media (min-width: 500px) and (max-width:600px)`]: {
    "& .container": {
      paddingTop: 0,
    },
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    paddingTop: 0,
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    height: "auto !important",
    marginTop: 0,
    "& .container": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "left",
      alignItems: "left",
      height: "auto",
      paddingTop: 0,
    },
  },
  [`@media ${props.theme.breakpoints.xss}`]: {
    height: "auto !important",
    marginTop: 0,
    paddingLeft: 10,
    "& .container": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "left",
      alignItems: "left",
      height: "auto",
      paddingTop: 0,
    },
    "& .container .buyDropdown": {
      width: 100,
    },
    "& .container .priceType": {
      width: 174,
    },
    "& .container .unitTextInput": {
      width: 100,
    },
  },
}));
export const CMOffer = styled.div((props) => ({
  display: "flex",
  justifyContent: "center",
  paddingTop: 24,
  paddingBottom: "77px",

  "& Button": {
    height: 53,
    width: 254,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    paddingTop: 0,
  },
  [`@media (min-width: 500px) and (max-width:600px)`]: {
    paddingTop: 0,
  },
  [`@media ${props.theme.breakpoints.xss}`]: {
    paddingTop: 0,
  },
  [`@media ${props.theme.breakpoints.md}`]: {
    paddingTop: 0,
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    paddingTop: 0,
  },
}));
export const CMOrderDetails = styled.div((props) => ({
  display: "flex",
  paddingLeft: 18,
  paddingTop: 5,

  " & .image-column": {
    width: 81,
  },
  "& .text-column": {
    flex: "1",
    paddingTop: "2%",
    paddingLeft: "2%",
    paddingBottom: 17,
    "& h5": {
      fontWeight: "normal",
    },
    "& h1": {
      fontSize: props.theme.fontSizes.h2,
      lineHeight: 1,
    },
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    paddingLeft: 32,
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    paddingLeft: 32,
  },
  [`@media ${props.theme.breakpoints.xss}`]: {
    paddingLeft: 10,
  },
}));

export const CMImage = styled(Image)((props) => ({
  border: "6px solid rgb(255, 255, 255)",
  boxShadow:
    "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 20px",
  width: 59,
  height: 59,
  margin: "8px auto",
  display: "block",
}));
export const CMDropdown = styled.select`
  width: 200,
  height: 50,
  `;
